<app-error-page-layout>
  <div
    class="bg-accent-interactive mx-auto mb-8 flex h-20 w-20 items-center justify-center rounded-full">
    <i class="ph-duotone ph-database text-accent-main text-4xl"></i>
  </div>

  <h1 class="mb-2">{{ 'error_pages.no_dataspace.title' | translate }}</h1>
  <p class="text-text-secondary mb-2">
    {{ 'error_pages.no_dataspace.description' | translate }}
  </p>
  <p class="text-text-tertiary text-sm">
    {{ 'error_pages.no_dataspace.contact' | translate }}
  </p>
</app-error-page-layout>
